import React, { Component } from "react";
import { PasswordPolicies } from "./password-policies";
import { Modal, Row, Form, Alert, Container, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { NotifierService } from "../../shared/services/notifier.service";
import { DataService } from "../../shared/services/data.service";
import { SpinnerService } from "../../shared/services/spinner.service";
import Button from "../../components/button/button";

type changePasswordProps = {
  forceChangePassword: any;
  show: any;
  userId: any;
  closeChangePasswordModal: any;
  logout: any;
};

interface ChangePasswordState {
  showPasswordPolicy?: boolean;
  message?: any;
  bulletList?: any;
  password?: any;
  newPassword?: any;
  confirmPassword?: any;
  error?: boolean;
}
class ChangePassword extends Component<
  changePasswordProps,
  ChangePasswordState
> {
  private ref: React.RefObject<HTMLInputElement>;
  constructor(props: any) {
    super(props);
    this.state = {
      showPasswordPolicy: false,
      message: null,
      bulletList: [],
      password: null,
      newPassword: null,
      confirmPassword: null,
      error: false,
    };

    this.ref = React.createRef();
  }

  setShowPasswordPolicy = (showPasswordPolicy: boolean) => {
    this.setState({ showPasswordPolicy });
  };

  handleInputChange = (event: any) => {
    const target = event.target;
    var value = target.value;
    const name = target.name;
    this.setState({ [name]: value, error: false });
  };

  changePassword = async (userId: any) => {
    let state: any = this.state;
    try {
      SpinnerService.show();
      const data = {
        password: state.password,
        newPassword: state.newPassword,
        confirmPassword: state.confirmPassword,
      };

      const changePassword = await DataService.put(
        `users/${userId}/changePassword`,
        data,
        {},
      );
      if (changePassword.status === "error") {
        let list: any = [];
        const messageSplitter = changePassword.err.split(". ");
        if (messageSplitter.length > 1 && messageSplitter[1]) {
          list = messageSplitter[1].slice(1, -1).split(",");
        }
        this.setState({
          message: messageSplitter[0],
          bulletList: list,
          error: true,
        });
      } else {
        NotifierService.success(
          "Password Changed successfully. You need to re-login. System will redirect you to login in 2 seconds.",
        );
        setTimeout(() => {
          this.props.logout();
        }, 2000);
      }
      SpinnerService.hide();
    } catch (e) {
      SpinnerService.hide();
      NotifierService.error("Invalid username or password.");
    }
  };

  closeTooltip = () => {
    this.setState({ showPasswordPolicy: false });
  };

  renderErrors = (bulletList: any) => {
    const item: any = [];
    let i = 0;
    for (let bullet of bulletList) {
      item.push(<li key={`bullet-${i++}`}>{bullet}</li>);
    }
    return item;
  };

  render() {
    const message = this.state.message;
    const bulletList = this.state.bulletList;
    const error = this.state.error;
    const forceChangePassword = this.props.forceChangePassword;
    const userId = this.props.userId;
    const show = this.props.show;
    const showPasswordPolicy = this.state.showPasswordPolicy;

    return (
      <Modal
        show={forceChangePassword || show}
        onHide={this.props.closeChangePasswordModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="modal-header-color change-password-header">
          <Modal.Title id="contained-modal-title-vcenter">
            <Container>
              <Row>
                <Col sm={11} xs={10}>
                  <img
                    src="/images/change_password.png"
                    width="40px"
                    alt="user icon"
                  />
                  &nbsp; Change Password
                </Col>
                <Col sm={1} xs={2}>
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    size="1x"
                    color="#0d61a7"
                    className={
                      forceChangePassword ? "show cursor" : "hide cursor"
                    }
                    onClick={() => this.props.logout()}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert
            variant="danger"
            className={error ? "display-block" : "display-none"}
          >
            {message}
            <ul>{this.renderErrors(bulletList)}</ul>
          </Alert>
          <Form id="changePasswordModal">
            <Form.Group>
              <Form.Control
                className="p-inputtext"
                type="password"
                name="password"
                id="password"
                placeholder="Current Password"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                className="p-inputtext"
                type="password"
                name="newPassword"
                id="newPassword"
                placeholder="New Password"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                className="p-inputtext"
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                placeholder="Confirm New Password"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group>
              <div
                className="tooltip-custom"
                id="password-policy"
                onClick={() => this.setShowPasswordPolicy(!showPasswordPolicy)}
              >
                Password Policy
                <span
                  className={
                    showPasswordPolicy ? "tooltiptext show" : "tooltiptext hide"
                  }
                >
                  <PasswordPolicies closeTooltip={() => this.closeTooltip} />
                </span>
              </div>
            </Form.Group>
            <Form.Group className="pt-2">
              <Row>
                <div className={forceChangePassword ? "col-12" : "col-6"}>
                  <Button
                    className=""
                    value="Save"
                    onClick={() => this.changePassword(userId)}
                  ></Button>
                </div>
                <div
                  className={
                    forceChangePassword ? "display-none col-6" : "col-6"
                  }
                >
                  <Button
                    className="btn-non-primary btn-default"
                    value="Cancel"
                    onClick={this.props.closeChangePasswordModal}
                  ></Button>
                </div>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}

export const ChangePasswordModal = ChangePassword;
